import React from 'react'

function AddPayPal() {
  return (
    <div>
      
    </div>
  )
}

export default AddPayPal
